<app-page [content]="content" />

<ng-template #content>
  <h1 class="text-bold m-b-5">Something unexpected happened...</h1>

  <p>
    Unfortunately we're not able to understand your request. Please check the link that brought you here and try again.
  </p>

  <p>{{ errorMessage }}</p>
</ng-template>
